import React from 'react'
import { BlockMain } from '@blocks/BlockMain'
import { ApplicationForms } from '@shared/components/forms/application'
import { scrollToApplicationForm } from '@shared/components/forms/application/cross'
import { Image } from '@shared/components/image'
import PageAnimation from '@shared/components/page-animation'
import { Faq } from '@shared/components/sections/faq'
import { Feedback } from '@shared/components/sections/feedback'
import { OurManagers } from '@shared/components/sections/our-managers'

import { AboutLoan } from './screens/about-loan'

import styles from './style.module.scss'

export const LoanNaPokupkuDoma = () => {
	return (
		<PageAnimation>
			<BlockMain
				adornmentClassname={styles.mainAdornment}
				imageAdornmentWrapClassName={styles.imageAdornment}
				data={{
					title: 'Кредит\xA0на покупку дома в\xA0%city_pr%?',
					imageAlt: 'Кредит на покупку дома',
					subtitle: (
						<>
							Получите кредит на&nbsp;покупку частного дома или&nbsp;земельного участка
							без&nbsp;первоначального взноса и&nbsp;лишних проверок
						</>
					),
					textItems: [
						'До 15 млн рублей',
						'Лояльны к кредитной истории',
						<>Не обязательно приносить документы о&nbsp;подтверждении дохода</>,
						<>Без очередей и&nbsp;траты времени на&nbsp;дорогу</>,
					],
					customImage: <Image name='KV-house-isolated.png' className={styles.mainImage} />,
					buttonText: 'Оставить заявку',
				}}
				className={styles.greenBg}
				buttonProps={{
					onClick: scrollToApplicationForm,
				}}
			/>
			<AboutLoan />
			<ApplicationForms.Cross />
			<OurManagers />
			<Feedback title='Отзывы клиентов' />
			<Faq
				accordionElements={[
					{
						title: 'Как проходит подписание документов при оформлении кредита на покупку дома?',
						content: (
							<div>
								Процесс состоит из нескольких шагов.
								<p>
									<b>Шаг 1.</b> Наш представитель приезжает к вам с полным пакетом документов,
									подробно рассказывает о том, как будет проводиться процедура.
								</p>
								<p>
									<b>Шаг 2.</b> Экземпляры документов дополнительно подписываются в печатном виде.
									Каждый участник сделки получает пакет документов на руки.
								</p>
								<p>
									<b>Шаг 3.</b> Мы выпускаем электронную подпись для вас и подписываем с вами
									электронный пакет документов через личный кабинет и приложение myDSS.
								</p>
							</div>
						),
					},
					{
						title: 'Возможно ли получить заём, если были просрочки и плохая кредитная история?',
						content: (
							<div>
								Мы лояльно относимся к кредитной истории. Наша тактика рассмотрения заявок
								отличается от банковской: стараемся находить индивидуальный подход к каждому
								клиенту. Иногда можем глубже проанализировать ситуацию или выйти на переговоры,
								чтобы уточнить детали.
							</div>
						),
					},
					{
						title: 'В каком форме будет предоставлен договор?',
						content: 'Договор предоставляется в печатной и электронной формах.',
					},
					{
						title: 'Как быстро деньги придут на счёт?',
						content:
							'Чаще всего деньги поступают на счёт не позднее 1–2 рабочих дней после регистрации сделки.',
					},
					{
						title: 'Есть ли комиссия за платежи по кредиту на покупку дома?',
						content: (
							<div>
								Это зависит от банка, через который отправляются деньги. Например, без комиссии
								можно внести платежи через Сбербанк, Тинькофф Банк, Альфа-Банк или банк Открытие. В
								этом списке могут быть и другие компании — уточняйте о комиссии у своего банка.
							</div>
						),
					},
					{
						title: 'Как получить справку о полном погашении кредита на покупку дома?',
						content: (
							<div>
								После того, как кредит закрывается, мы готовим справку о полном погашении долга.
								Отправляем её по электронной почте, в WhatsApp или заказным письмом, если нужен
								оригинал.
							</div>
						),
					},
				]}
			/>
		</PageAnimation>
	)
}
